import { type FinanceProductFormValues } from '..';
import { type OptionalRangeValuePayload } from '../../../../../api';
import { type NumberFormatFn } from '../../../../../utilities/useFormats';

const getFinderVariantNameWithParameters = (
    vehicleReferenceParameters: FinanceProductFormValues['vehicleReferenceParameters'],
    mileageUnitLabel: string,
    formatAmount: NumberFormatFn
) => {
    const getMileageString = (unit: string, formatAmount: NumberFormatFn, mileage?: OptionalRangeValuePayload) => {
        if (!mileage) {
            return '';
        }

        return `${formatAmount(mileage.from)} - ${formatAmount(mileage.to)} ${unit}`;
    };

    const getModelYearString = (modelYear?: OptionalRangeValuePayload) => {
        if (!modelYear) {
            return '';
        }

        return `${modelYear.from} - ${modelYear.to}`;
    };

    const getEngineTypeString = (engineType?: string[]) => {
        if (!engineType) {
            return '';
        }

        return engineType.join(',');
    };

    const { engineType, mileage, modelYear, variants } = vehicleReferenceParameters.finderVehicle;

    const mileageString = getMileageString(mileageUnitLabel, formatAmount, mileage);
    const modelYearString = getModelYearString(modelYear);
    const engineTypeString = getEngineTypeString(engineType);

    return [engineTypeString, variants, mileageString, modelYearString].filter(Boolean).join(' , ');
};

export default getFinderVariantNameWithParameters;
